<template>
  <div id="orders">
    <mt-header class="dl_header_new_bg" fixed>
      <mt-button slot="left" @click.native="$router.back()">
        <img class="go-back" src="@/assets/img/ico_back.png" />
      </mt-button>
    </mt-header>
    <div class="container">
      <div class="page-head">
        <h2 class="page-title">{{ $t("package.orders") }}</h2>
      </div>
      <div class="content">
        <div class="list">
			<div class="item" 
				v-for="(item, index) in list" 
				:key="index"
				@click="handleDetail(item)">
				<div class="icon">
					<img class="img_icon" src="@/assets/img/package/ico_package.png" />
				</div>
				<div class="item-body">
					<div class="order-id">{{item.order_id}}</div>
					<div class="order-time">{{$t('package.time')}}: {{item.ctime}}</div>
					<div class="order-amount">
						{{$t('package.amount')}}: 
						<span style="color: #ff6600;">{{item.amount}}</span> ({{item.pay_type}})
					</div>
				</div>
				<div class="pay-type">
					<div class="body">{{item.pay_type}}</div>
					<div class="label">{{$t('package.pay_type')}}</div>
				</div>
			</div>
		</div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatTime } from "@/utils/index";
import { Toast,CellSwipe } from "mint-ui";
import { httpGetPackageOrders } from "@/api/hangqing";
export default {
  data() {
    return {
      list: [],
	  params:{
		  page: 1
	  }
    };
  },
  created() {},
  activated() {
  },
  mounted() {
    this.wrapperWidth = document.documentElement.clientWidth - 90;
	this.getList();
  },
  methods: {
    getList: function() {
      let _this = this
      var p = this.params;
      httpGetPackageOrders(p)
        .then(res => {
    		if(res.code != 1){
    			Toast(this.$t("package.nologin"));
    			setTimeout(function(){
    				_this.$router.push("/index/home");
    			},2000)
    		}
          this.list = res.data.data;
          this.$refs.loadmore.onTopLoaded();
          this.$refs.loadmore.onBottomLoaded();
        })
        .catch(() => {
          this.$refs.loadmore.onTopLoaded();
          this.$refs.loadmore.onBottomLoaded();
        });
    },
	handleDetail(item){
		this.$router.push("/index/package-orders-detail?id="+item.id);
	}
  },
};
</script>
<!-- <style>
	
</style> -->
<style scoped lang="scss">
*{
	box-sizing: border-box;
}
#orders {
  width: 100%;
   height: 100%;
  padding-top: 50px !important;
    background-color:#F6F8FA;
}
.go-back{
  width: 20px;
  height: 20px;
}
.page-head{
	display: flex;
	justify-content: space-between;
	align-items: center;
  margin-bottom: 20px;

}
.page-title{
  font-size: 1.25rem;
  color:#12172E;  
}
.add {
  width: 24px;
  height: 24px;
}
.container {
  padding: 0 30px;
}
#addressBook ::v-deep .mint-button--normal{
	padding: 0 !important;
}
.content { 
	width: 100%;
}
.list{
	padding-bottom: 64px;
	.item{
		padding: 20px;
		border-radius: 8px;
		box-shadow: 0 20px 15px 8px #dae5f0;
		margin-top: 20px;
		background-color: #ffffff;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.icon{
			width: 48px;
			.img_icon{
				width: 48px;
			}
		}
		.item-body{
			width: calc(100% - 48px - 10px - 64px);
			.order-id{
				font-size: 0.875rem;
				font-weight: bold;
			}
			.order-amount{
				font-size: 0.75rem;
				color: #999999;
				padding: 5px 0 0 0;
			}
			.order-time{
				font-size: 0.75rem;
				color: #999999;
				padding: 5px 0 0 0;
			}
		}
		.pay-type{
			width: 64px;
			text-align: center;
			.body{
				font-size: 0.75rem;
				font-weight: bold;
			}
			.label{
				font-size: 0.75rem;
				color: #999999;
			}
		}
	}
}

</style>